// disable transitions during breakpoint change events
$(function () {
  const $html = $('html');

  // remove transitions while resizing
  $(document).on(Sq.Breakpoint.Event.BREAKPOINTCHANGE, () => {
    clearTimeout(window.endResizing);
    $html.attr('data-resizing', true);
    window.endResizing = setTimeout(() => {
      $html.removeAttr('data-resizing');
    }, 50);
  });
});
